// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"GL-z","carouselContainer":"HL-z"};